import type { AuthPayload, ChangePasswordInput, LoginInput, RegisterCompanyInput } from '@stoplord/shared';
import { api } from '@/lib/api';
import { useAuth } from '@/store/auth';

export const authApi = {
  login: async (b: LoginInput) => {
    const p = await api.post<AuthPayload>('/auth/login', b);
    useAuth.getState().setSession(p);
    try {
      localStorage.setItem('stoplord-workspace', b.workspace);
    } catch {
      /* ignore */
    }
    return p;
  },
  register: async (b: RegisterCompanyInput) => {
    const p = await api.post<AuthPayload>('/auth/register', b);
    useAuth.getState().setSession(p);
    return p;
  },
  logout: async () => {
    try {
      await api.post('/auth/logout');
    } finally {
      useAuth.getState().clear('logout');
    }
  },
  me: async () => {
    const p = await api.get<Omit<AuthPayload, 'accessToken' | 'accessTokenExpiresAt'>>('/auth/me');
    useAuth.getState().setProfile(p);
    return p;
  },
  changePassword: (b: ChangePasswordInput) => api.post('/auth/change-password', b),
  sessions: () =>
    api.get<{
      sessions: { _id: string; device: { browser: string; os: string; device: string }; ip?: string; createdAt: string; lastSeenAt: string; current: boolean }[];
      loginHistory: { _id: string; success: boolean; reason: string; ip?: string; device?: { browser: string; os: string }; createdAt: string }[];
    }>('/auth/sessions'),
  revokeSession: (id: string) => api.delete(`/auth/sessions/${id}`),
};
